<div class="flex w-full flex-col items-center gap-8">
  <h1 class="">
    {{ (isCreate ? 'login.create_password' : 'login.reset_your_password') | translate }}
  </h1>

  <pl-loader *ngIf="isLoading"></pl-loader>

  <ng-container *ngIf="!isLoading">
    <form
      *ngIf="!showAfterCreateInfo"
      class="flex w-full flex-col items-center gap-8"
      [formGroup]="passwordSetupForm"
      #myForm="ngForm"
    >
      <div class="flex w-full flex-col">
        <p class="text-lg">{{ 'login.password_requirements.list_header' | translate }}</p>
        <ul class="ml-3.5 list-disc text-lg text-pl-gray-450">
          <li>{{ 'login.password_requirements.list_1' | translate }}</li>
          <li>{{ 'login.password_requirements.list_2' | translate }}</li>
        </ul>
      </div>

      <div class="w-full bg-pl-error p-4 text-sm italic text-white" [hidden]="!error || isLoading || !myForm.submitted">
        {{ error }}
      </div>

      <pl-input
        class="w-full"
        [formControlName]="FormControlName.password"
        [isFormSubmitted]="myForm.submitted"
        [label]="'login.new_password' | translate"
        [requiredErrorMessage]="'login.errors.enter_new_password' | translate"
        [patternErrorMessage]="'login.errors.password_pattern' | translate"
        [showEyeIconToTogglePassword]="true"
        [showRightIcon]="false"
        [type]="PlInputType.password"
      />
      <pl-input
        class="w-full"
        [formControlName]="FormControlName.password2"
        [isFormSubmitted]="myForm.submitted"
        [label]="'login.retype_password' | translate"
        [requiredErrorMessage]="'login.errors.enter_new_same_password' | translate"
        [patternErrorMessage]="'login.errors.password_pattern' | translate"
        [showEyeIconToTogglePassword]="true"
        [showRightIcon]="false"
        [type]="PlInputType.password"
      />
      <pl-button
        class="block w-full"
        [variant]="ButtonVariant.blue"
        [padding]="ButtonPadding.big"
        (click)="setupPassword()"
      >
        {{ (isCreate ? 'login.create_password' : 'login.reset_your_password') | translate }}
      </pl-button>
    </form>

    <ng-container *ngIf="showAfterCreateInfo">
      <p class="text-lg font-bold">{{ 'login.success_creating_password' | translate }}</p>

      <pl-button
        class="w-full"
        [variant]="ButtonVariant.blue"
        [padding]="ButtonPadding.big"
        (click)="showLoginScreen()"
      >
        {{ 'login.back_to_login' | translate }}
      </pl-button>
    </ng-container>
  </ng-container>

  <p class="text-center text-lg text-pl-gray-450">{{ 'login.need_help_contact_support' | translate }}</p>
</div>
